import { render, staticRenderFns } from "./ApprovalDone.vue?vue&type=template&id=5c1c51a3&scoped=true&"
import script from "./ApprovalDone.vue?vue&type=script&lang=js&"
export * from "./ApprovalDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1c51a3",
  null
  
)

export default component.exports